import { DocumentNode } from 'graphql';
import { useForm } from 'react-form-state-manager';
import { useTranslation } from 'react-i18next';

import { Registration } from '../helpers';
import { useNotifier } from '../../../common/Notifications/NotificationProvider';
import GetRegistrationSummaryForDashboardQuery from './GetRegistrationSummaryForDashboardQuery';
import LeaveWaitlistMutation from './LeaveWaitlistMutation';
import UI from '../../../common/UI';
import useMutation from '../../../api/useMutation';

export interface LeaveWaitlistFormProps {
  registration: Registration;
  refetchQueries?: DocumentNode[];
}

const LeaveWaitlistForm = ({
  registration,
  refetchQueries = [GetRegistrationSummaryForDashboardQuery],
}: LeaveWaitlistFormProps) => {
  const { t } = useTranslation();
  const notifier = useNotifier();

  const form = useForm({
    values: {
      leave_waitlist: false,
    },
  });

  const [leaveWaitlist, { error, loading }] = useMutation(
    LeaveWaitlistMutation,
    {
      variables: {
        input: {
          registration: { id: registration.id },
        },
      },
      onCompleted: () => {
        notifier.success(t('information_saved'));
      },
      onError: () => {
        notifier.error(t('something_went_wrong'));
      },
      refetchQueries,
    },
  );

  return (
    <UI.FormGrid sc={{ padding: [3, 4] }}>
      <UI.Form onSubmit={() => leaveWaitlist()}>
        <UI.FormGrid>
          <UI.ServerErrors error={error} />

          <UI.Div>
            {t('leave_waitlist_description')}
          </UI.Div>

          <UI.InputGroup>
            <UI.Checkbox {...form.checkbox('leave_waitlist')}>
              {t('leave_waitlist')}
            </UI.Checkbox>
          </UI.InputGroup>

          <UI.Button
            type="submit"
            sc={{ brand: 'secondary', loading }}
            disabled={loading || !form.values.leave_waitlist}
          >
            {t('confirm')}
          </UI.Button>
        </UI.FormGrid>
      </UI.Form>
    </UI.FormGrid>
  );
};

export default LeaveWaitlistForm;
